/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const Access = {
  APLICATION: 1532,
  MENU_ACCESS: {
    DASHBOARD: 317,
    ENQUIRIES: 318,
  },
  PERSON_EDIT: "457",
  MANAGEMENT: {
    READ: 462,
    EDIT_ECONOMIC_INDEXERS: 1124,
    READ_DOCUMENT_PARAMETERS: 1288,
    EDIT_DOCUMENT_PARAMETERS: 1289,
    MODULE_PERSON: 994,
    MODULE_ACCESS_GROUP: 995,
    MODULE_ACCESS_PROFILE: 996,
    CREATE_PERSON: 457,
    EDIT_PERSON: 311,
  },
  MANAGEMENT_DOCUMENT_PARAMS: {
    READ: 1288,
    EDIT_DOCUMENT_PARAMETERS: 1289,
  },
  MANAGEMENT_USER:{
    READ: 1080,
    EDIT_USER: 1069,
    CREATE_USER: 1070
  },
  MANAGEMENT_PRODUCT:{
    READ: 1003,
  },
  MANAGEMENT_PERSON:{
    READ: 994,
    CREATE_PERSON: 457,
    EDIT_PERSON: 311,
    CREATE_USER: 1070,
    EDIT_USER: 1069,
  },
  MANAGEMENT_ACCESS_GROUP :{
    READ: 995
  },
  MANAGEMENT_PROFILE:{
    READ: 996
  },
  MANAGEMENT_PLANS:{
    READ: 1001
  },
  MANAGEMENT_COVERAGE:{
    READ: 1002
  },
  MANAGEMENT_ECONOMIC_INDEXERS:{
    READ: 1124
  },
  LIST: {
    READ_ENQUIRY: 1058,
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY: 429,
    DOCUMENT_GENERAL: 313,
    CLONE_QUOTE: 1584,
    ROUTE_POLICIES_CREATE_ENDORSEMENT: 476,
    CREATE_ENDORSEMENT: 476
  },

  ROUTE_CREATEENQUIRITY: {
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY_SAVE: 430,
    NBI_REQUEST_APPROVE_REJECT: 433,
    ROUTE_POLICIES_CREATE_ENDORSEMENT: 476,
    CANCEL_ENQUIRY: 576,
    APPROVE_REJECT_ENDORSEMENT: 1591,
    EDIT_ENDORSEMENT_SAVE: 1592,
    GENERATE_ENDORSEMENT: 1593,
    CANCEL_ENDORSEMENT: 1602,
    REQUEST_ADDITIONAL_INFO: 1061,
    MARKETING_COMPOSITION: 442,
    REQUEST_ENDORSEMENT: 1590
  },

  ROUTE_EDITENQUIRITY: {
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY_SAVE: 430,
    NBI_REQUEST_APPROVE_REJECT: 433,
    ROUTE_POLICIES_CREATE_ENDORSEMENT: 476,
    CANCEL_ENQUIRY: 576,
    APPROVE_REJECT_ENDORSEMENT: 1591,
    EDIT_ENDORSEMENT_SAVE: 1592,
    GENERATE_ENDORSEMENT: 1593,
    CANCEL_ENDORSEMENT: 1602,
    REQUEST_ADDITIONAL_INFO: 1061,
    MARKETING_COMPOSITION: 442,
    REQUEST_ENDORSEMENT: 1590
  },

  ROUTE_POLICIES_AND_ENDORSEMENTS_LIST: {
    CLONE_QUOTE: 1584,
    CREATE_ENDORSEMENT: 476,
  },

  ROUTE_QUOTESPLANS: {
    READ_ENQUIRY: 1058,
    NBI_REQUEST_APPROVE_REJECT: 433,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    DOCUMENT_GENERAL: 313,
    EDIT_ENQUIRY: 429,
    VIEW_NOTES: 732,
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY_SAVE: 430,
    EDIT_ENQUIRY_GENERATE_NBI_REQUEST: 431,
    FORMALIZE_CREDIT_ANALYSIS: 726,
    REGENERATE_CREDIT_ANALYSIS: 725,
    ANALYZE_CREDIT_ANALYSIS_SAVE: 721,
    CREATE_CREDIT_ANALYSIS: 717,
    EDIT_CREDIT_ANALYSIS: 718,
    REANALYZE_CREDIT_ANALYSIS: 727,
    REJECT_CREDIT_ANALYSIS: 720,
    GENERATE_CREDIT_ANALYSIS: 722,
    SEND_CREDIT_ANALYSIS: 723,
    CANCEL_SEND_CREDIT_ANALYSIS: 724,
    ORDER_TO_BIND_GENERATE: 421,
    ORDER_TO_BIND_APPROVE_REJECT: 422,
    MANUAL_SIGNATURE: 972,
    DOCUMENT_PENDING: 973,
    GENERATE_MRC: 427,
    REQUEST_ADDITIONAL_INFO: 1061,
    ROUTE_POLICIES_CREATE_ENDORSEMENT: 476,
    CANCEL_ENQUIRY: 576,
  },

  ROUTE_QUOTESPLANS_RCG: {
    NBI_REQUEST_APPROVE_REJECT: 433,
    MARKETS_SELECTION: 436,
    DOCUMENT_GENERAL: 313,
    VIEW_NOTES: 732,
    ORDER_TO_BIND_GENERATE: 421,
    GENERATE_MRC: 427,
    REQUEST_ADDITIONAL_INFO: 1061,
    ROUTE_POLICIES_CREATE_ENDORSEMENT: 476,
    CANCEL_ENQUIRY: 576,
    ENDORSEMENT_APPROVE_REJECT: 1591,
    EXECUTE_ENDORSEMENT: 1589,
    CANCEL_ENDORSEMENT: 1602,
  },

  ROUTE_PAYMENT: {
    READ_ENQUIRY: 1058,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    ORDER_TO_BIND_GENERATE: 421,
    EDIT_ENQUIRY: 429,
    NBI_REQUEST_APPROVE_REJECT: 433,
    VIEW_NOTES: 732,
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY_SAVE: 430,
    EDIT_ENQUIRY_GENERATE_NBI_REQUEST: 431,
    DOCUMENT_GENERAL: 313,
    FORMALIZE_CREDIT_ANALYSIS: 726,
    REGENERATE_CREDIT_ANALYSIS: 725,
    ANALYZE_CREDIT_ANALYSIS_SAVE: 721,
    CREATE_CREDIT_ANALYSIS: 717,
    EDIT_CREDIT_ANALYSIS: 718,
    REANALYZE_CREDIT_ANALYSIS: 727,
    REJECT_CREDIT_ANALYSIS: 720,
    GENERATE_CREDIT_ANALYSIS: 722,
    SEND_CREDIT_ANALYSIS: 723,
    CANCEL_SEND_CREDIT_ANALYSIS: 724,
    ORDER_TO_BIND_APPROVE_REJECT: 422,
    MANUAL_SIGNATURE: 972,
    DOCUMENT_PENDING: 973,
    ROUTE_EXECUTION_SEND: 423,
    EXECUTE_ENDORSEMENT: 1589,
  },

  ROUTE_QUOTE_ISSUE: {
    READ_ENQUIRY: 1058,
    ORDER_TO_BIND_APPROVE_REJECT: 422,
    NBI_REQUEST_APPROVE_REJECT: 433,
    EDIT_ENQUIRY: 429,
    VIEW_NOTES: 732,
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY_SAVE: 430,
    EDIT_ENQUIRY_GENERATE_NBI_REQUEST: 431,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    DOCUMENT_GENERAL: 313,
    FORMALIZE_CREDIT_ANALYSIS: 726,
    REGENERATE_CREDIT_ANALYSIS: 725,
    ANALYZE_CREDIT_ANALYSIS_SAVE: 721,
    CREATE_CREDIT_ANALYSIS: 717,
    EDIT_CREDIT_ANALYSIS: 718,
    REANALYZE_CREDIT_ANALYSIS: 727,
    REJECT_CREDIT_ANALYSIS: 720,
    GENERATE_CREDIT_ANALYSIS: 722,
    SEND_CREDIT_ANALYSIS: 723,
    CANCEL_SEND_CREDIT_ANALYSIS: 724,
    MANUAL_SIGNATURE: 972,
    DOCUMENT_PENDING: 973,
    CANCEL_ENQUIRY: 576,
  },

  ROUTE_DOCUMENTMANAGEMENT: {
    READ_ENQUIRY: 1058,
    DOCUMENT_GENERAL: 313,
    VIEW_NOTES: 732,
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY: 429,
    EDIT_ENQUIRY_SAVE: 430,
    EDIT_ENQUIRY_GENERATE_NBI_REQUEST: 431,
    NBI_REQUEST_APPROVE_REJECT: 433,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    FORMALIZE_CREDIT_ANALYSIS: 726,
    REGENERATE_CREDIT_ANALYSIS: 725,
    ANALYZE_CREDIT_ANALYSIS_SAVE: 721,
    CREATE_CREDIT_ANALYSIS: 717,
    EDIT_CREDIT_ANALYSIS: 718,
    REANALYZE_CREDIT_ANALYSIS: 727,
    REJECT_CREDIT_ANALYSIS: 720,
    GENERATE_CREDIT_ANALYSIS: 722,
    SEND_CREDIT_ANALYSIS: 723,
    CANCEL_SEND_CREDIT_ANALYSIS: 724,
    ORDER_TO_BIND_GENERATE: 421,
    ORDER_TO_BIND_APPROVE_REJECT: 422,
    MANUAL_SIGNATURE: 972,
    DOCUMENT_PENDING: 973
  },

  ROUTE_ADJUSTMENTS_AND_CORRECTIONS: {
    EXECUTE_ENDORSEMENT: 1589,
    ENDORSEMENT_APPROVE_REJECT: 1591,
  }
}

export default Access;
